import { css } from 'emotion';

export const fullHeight = css({
	height: '100%',
});
